var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Screening.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-98d24e5c!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Screening.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/domains/event/components/show/paper/Screening.vue
// module id = 674
// module chunks = 2